<div class="empty animate__animated animate__fadeIn">
  <img *ngIf="icon" [src]="icon" [style.width]="iconWidth" />
  <div class="text" [class.small]="smallText">{{ text }}</div>
  <ng-content></ng-content>
</div>
